<div class="invoice-history-block">
    <div class="breadcrumb-block">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="javascript:void(0)" @click.prevent="redirectToInvoicehistory"
              >Invoice history</a
            >
          </li>
          <li aria-current="page" class="breadcrumb-item active">
            Invoice detail
          </li>
        </ol>
      </nav>
    </div>
  
    <div class="row">
      <div class="col-lg-7">
        <div class="top-btn mb-3">
          <a href="javascript:void(0)" class="btn btn-primary btn-sm"
            ><i class="fas fa-check"></i> Mark as paid</a
          >
          <a
            href="javascript:void(0)"
            data-toggle="modal"
            class="btn btn-success btn-sm"
            ><i class="fas fa-envelope"></i> Send as email</a
          >
          <a href="javascript:void(0)" class="btn btn-danger btn-sm"
            ><i class="fas fa-times"></i> Cancel</a
          >
        </div>
        <table
          align="center"
          border="0"
          cellpadding="0"
          cellspacing="0"
          style="border:1px solid #E0E0E0"
          width="100%"
        >
          <tbody>
            <tr>
              <td>
                <div style="height: 2px;background: #37b34a;display: block"></div>
              </td>
            </tr>
            <tr style="background: #ececec">
              <td>
                &nbsp;
              </td>
            </tr>
            <tr style="background: #ececec">
              <td align="center">
                <img src="../img/travlize-logo.png" style="width: 120px;" />
              </td>
            </tr>
            <tr style="background: #ececec">
              <td>
                &nbsp;
              </td>
            </tr>
            <tr style="background: #ececec">
              <td align="center">
                <p
                  style="color:#333;font-weight: 600;font-family: Arial, Helvetica, sans-serif;font-size: 14px;margin-top:0"
                >
                  Choose best travel package, hotel booking, and flight in Nepal.
                </p>
              </td>
            </tr>
            <tr style="background: #ececec">
              <td>
                &nbsp;
              </td>
            </tr>
            <tr>
              <td>
                <div style="height: 1px;background: #eee;display: block"></div>
              </td>
            </tr>
            <tr>
              <td>
                &nbsp;
              </td>
            </tr>
            <tr>
              <td style="padding: 0 20px;">
                <p
                v-if="invoiceDetails.account.company_name"
                  style="color:#333;font-weight:600;font-family: Arial, Helvetica, sans-serif;font-size: 16px;margin-top:0"
                >
                  Hi {{invoiceDetails.account.company_name}}
                </p>
                <p
                  style="color:#333;font-family: Arial, Helvetica, sans-serif;font-size: 14px;margin-top:0;margin-bottom: 10px;"
                >
                  Your order has been successfully places.Below you will find the
                  invoice of your order.We will get back to you shortly.Below you
                  will find the invoice of your order.We will get back to you
                  shortly.Below you will find the invoice of your order.We will
                  get back to you shortly.
                </p>
                <p
                  style="color:#333;font-family: Arial, Helvetica, sans-serif;font-size: 14px;margin-top:0;margin-bottom:0px;"
                >
                  <span style="font-weight: 600;">Order number:</span> 38391
                </p>
                <p
                  style="color:#333;font-family: Arial, Helvetica, sans-serif;font-size: 14px;margin-top:0;margin-bottom: 15px;"
                >
                  <span style="font-weight: 600;">Order date:</span> 2019-11-22
                </p>
              </td>
            </tr>
            <tr>
              <td style="padding: 0 20px;">
                <table cellpadding="0" cellspacing="0" width="100%">
                  <tbody>
                    <tr>
                      <td width="50%">
                        <p
                          style="color:#333333;font-weight:600;font-family: Arial, Helvetica, sans-serif;font-size:16px;margin-bottom: 5px;"
                        >
                          Invoiced To
                        </p>
                        <p
                        v-if="invoiceDetails.account.company_name"
                          style="font-family:Arial,Helvetica, sans-serif; color:#333333; font-size:14px;margin-bottom:0px"
                        >
                        {{invoiceDetails.account.company_name}}
                        </p>
                        <p
                          style="font-family:Arial,Helvetica, sans-serif; color:#333333; font-size:14px;margin:0px 0px 4px 0"
                        >
                          invoiceDetails.account.company_email
                        </p>
                        <p
                          style="font-family:Arial,Helvetica, sans-serif; color:#333333; font-size:14px;margin:0px 0px 10px 0"
                        >
                          {{invoiceDetails.account.company_contact1}}
                          {{invoiceDetails.account.company_contact2}}
                        </p>
                      </td>
                      <td width="50%">
                        <p
                          style="color:#333333;font-weight:600;font-family: Arial, Helvetica, sans-serif;font-size: 16px;margin-bottom: 5px;"
                        >
                          Invoiced From
                        </p>
                        <p
                          style="font-family:Arial,Helvetica, sans-serif; color:#333333; font-size:14px;margin-bottom:0px"
                        >
                          fromDetails.name
                        </p>
                        <p
                          style="font-family:Arial,Helvetica, sans-serif; color:#333333; font-size:14px;margin:0px 0px 4px 0"
                        >
                          fromDetails.email
                        </p>
                        <p
                          style="font-family:Arial,Helvetica, sans-serif; color:#333333; font-size:14px;margin:0px 0px 10px 0"
                        >
                          fromDetails.contact1 fromDetails.contact2
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
  
            <tr>
              <td>
                &nbsp;
              </td>
            </tr>
            <tr>
              <td style="padding: 0 20px;">
                <table cellpadding="0" cellspacing="0" width="100%">
                  <thead style="background: #ececec;">
                    <tr>
                      <th align="left" style="padding-left: 15px;">
                        <p
                          style="font-weight:bold;font-family:Arial,Helvetica, sans-serif; color:#333333; font-size:14px;margin-bottom:10px;margin-top:10px"
                        >
                          Title
                        </p>
                      </th>
                      <th align="left">
                        <p
                          style="font-weight:bold;font-family:Arial,Helvetica, sans-serif; color:#333333; font-size:14px;margin-bottom:10px;margin-top:10px"
                        >
                          Amount
                        </p>
                      </th>
                      <th align="left">
                        <p
                        v-if="invoiceDetails.account.company_name"
                          style="font-weight:bold;font-family:Arial,Helvetica, sans-serif; color:#333333; font-size:14px;margin-bottom:10px;margin-top:10px"
                        >
                         {{ invoiceDetails.account.company_name}}
                        </p>
                      </th>
                      <th align="left">
                        <p
                          style="font-weight:bold;font-family:Arial,Helvetica, sans-serif; color:#333333; font-size:14px;margin-bottom:10px;margin-top:10px"
                        >
                          Due date
                        </p>
                      </th>
                      <th align="left">
                        <p
                          style="font-weight:bold;font-family:Arial,Helvetica, sans-serif; color:#333333; font-size:14px;margin-bottom:10px;margin-top:10px"
                        >
                          Status
                        </p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="padding-left: 15px;">
                        <p
                          style="font-family:Arial,Helvetica, sans-serif; color:#333333; font-size:14px;margin-bottom:15px"
                        >
                          {{invoiceDetails.title}}
                        </p>
                      </td>
                      <td>
                        <p
                          style="font-family:Arial,Helvetica, sans-serif; color:#333333; font-size:14px;margin-bottom:15px"
                        >
                          {{invoiceDetails.amount}}
                        </p>
                      </td>
                      <td>
                        <p
                        v-if="invoiceDetails.account.company_name"
                          style="font-family:Arial,Helvetica, sans-serif; color:#333333; font-size:14px;margin-bottom:15px"
                        >
                          {{invoiceDetails.account.company_name}}
                        </p>
                      </td>
                      <td>
                        <p
                          style="font-family:Arial,Helvetica, sans-serif; color:#333333; font-size:14px;margin-bottom:15px"
                        >
                         {{ invoiceDetails.due_date}}
                        </p>
                      </td>
                      <td>
                        <p
                          style="font-family:Arial,Helvetica, sans-serif; color:#ffffff; font-size:14px;margin-bottom:15px;display: inline-block;
                          padding: 0px 10px;
                          border-radius: 4px;background: #28a745;"
                        >
                          Paid
                        </p>
                        <p
                          style="font-family:Arial,Helvetica, sans-serif; color:#ffffff; font-size:14px;margin-bottom:15px;display: inline-block;
                        padding: 0px 10px;
                        border-radius: 4px;background: #dc3545"
                        >
                          Not-Paid
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="5">
                        <div
                          style="height: 1px;background: #e0e0e0;display: block"
                        ></div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3" style="text-align:right">
                        &nbsp;
                      </td>
                      <td>
                        <p
                          style="font-family:Arial,Helvetica, sans-serif;font-weight: 600; color:#333333; font-size:16px;margin-bottom:15px"
                        >
                          Sub-total
                        </p>
                      </td>
                      <td>
                        <p
                          style="font-family:Arial,Helvetica, sans-serif;font-weight: 600; color:#333333; font-size:16px;margin-bottom:15px"
                        >
                          $1400.00
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3" style="text-align:right">
                        &nbsp;
                      </td>
                      <td>
                        <p
                          style="font-family:Arial,Helvetica, sans-serif;font-weight: 600; color:#333333; font-size:16px;margin-bottom:15px"
                        >
                          Tax (7%)
                        </p>
                      </td>
                      <td>
                        <p
                          style="font-family:Arial,Helvetica, sans-serif;font-weight: 600; color:#333333; font-size:16px;margin-bottom:15px"
                        >
                          $40.50
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3" style="text-align:right">
                        &nbsp;
                      </td>
                      <td>
                        <p
                          style="font-family:Arial,Helvetica, sans-serif;font-weight: 600; color:#333333; font-size:16px;margin-bottom:15px"
                        >
                          Total
                        </p>
                      </td>
                      <td>
                        <p
                          style="font-family:Arial,Helvetica, sans-serif;font-weight: 600; color:#333333; font-size:16px;margin-bottom:15px"
                        >
                          $1800.50
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
  
            <tr>
              <td style="padding: 0 20px;">
                <p
                  style="color:#333;font-family: Arial, Helvetica, sans-serif;font-size: 14px;margin-bottom: 0px;margin-top: 10px;"
                >
                  Thanks for using our services. We hope to work with in future
                  too.
                </p>
                <p
                  style="color:#333;font-family: Arial, Helvetica, sans-serif;font-size: 14px;margin-bottom: 0px;margin-top: 10px;"
                >
                  Best Regards,
                </p>
                <p
                  style="color:#37b34a;font-weight:600;font-family: Arial, Helvetica, sans-serif;font-size: 14px;margin-top:0px;margin-bottom: 15px;"
                >
                  Travlize Support Team
                </p>
              </td>
            </tr>
            <tr style="background: #f3f3f3;">
              <td>
                &nbsp;
              </td>
            </tr>
            <tr style="background: #f3f3f3;">
              <td align="center" style="padding: 0 20px;">
                <p
                  style="color:#333;font-family: Arial, Helvetica, sans-serif;font-size: 13px;line-height: 18px;"
                >
                  Travlize is the best platform for different hotels, airline and
                  travel agencies to showcase their products online. We help you
                  all the way to find potential customers.
                </p>
              </td>
            </tr>
            <tr style="background: #f3f3f3;">
              <td>
                &nbsp;
              </td>
            </tr>
            <tr style="background: #f3f3f3;">
              <td style="padding: 0 20px;" align="center">
                <span
                  style="font-family: Arial, Helvetica, sans-serif;font-size: 13px;margin-bottom: 5px;"
                >
                  <a href="" style="color:#37b34a">Book Hotels</a>
                </span>
                <span
                  style="font-family: Arial, Helvetica, sans-serif;font-size: 13px;margin:0 10px 5px 15px;"
                >
                  <a href="" style="color:#37b34a">Travel and Tour Packages</a>
                </span>
                <span
                  style="font-family: Arial, Helvetica, sans-serif;font-size: 13px;margin-bottom: 5px;"
                >
                  <a href="" style="color:#37b34a">Book a Flight</a>
                </span>
              </td>
            </tr>
            <tr style="background: #f3f3f3;">
              <td>
                &nbsp;
              </td>
            </tr>
            <tr style="background: #38b24b;">
              <td style="padding: 5px 20px;">
                <table style="    width: 100%;">
                  <tbody>
                    <tr>
                      <td>
                        <a href="#" style="text-decoration: none;">
                          <p
                            style="color:#fff;font-family: Arial, Helvetica, sans-serif;font-size: 13px;margin-top:0"
                          >
                            Travlize
                          </p>
                        </a>
                      </td>
                      <td align="center">
                        <p
                          style="color:#fff;font-family: Arial, Helvetica, sans-serif;font-size: 13px;margin-top:0"
                        >
                          <img alt="" src="../img/map-white.png" width="14px" />
                          Kathmandu,Nepal
                        </p>
                      </td>
                      <td align="right">
                        <p
                          style="color:#fff;font-family: Arial, Helvetica, sans-serif;font-size: 13px;margin-top:0"
                        >
                          <span style="margin-right: 5px;">
                            <img
                              alt=""
                              src="../img/phone-white.png"
                              width="11px"
                            />
                            01-123678</span
                          >
                        </p>
                      </td>
                      <td align="right">
                        <p
                          style="color:#fff;font-family: Arial, Helvetica, sans-serif;font-size: 13px;margin-top:0"
                        >
                          <span style="margin-left: 5px;">
                            <img
                              alt=""
                              src="../img/envelope-solid-white.png"
                              width="11px"
                            />
                            travlize-support@gmail.com</span
                          >
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-5">
        <div class="white-box">
          <div class="invoice-log ">
            <div class="table-title pl-0 pb-0"><h5>Other info</h5></div>
            <hr />
  
            <div class="block-list">
              <ul class="pl-0">
                <li>
                  <i class="fas fa-envelope"></i> Last email sent on
                  <strong>2019-12-12 01:23:23 01:11:10 PM</strong>
                </li>
                <li>
                  <i class="fas fa-check"></i> Invoice paid on
                  <strong>2019-12-12 01:34:33 AM</strong>
                </li>
                <li>
                  <i class="fas fa-dollar-sign"></i> Payment remarks:
                  <strong>Paid by Cheque</strong>
                </li>
                <li>
                  <i class="fas fa-times"></i> Invoice cancelled on
                  <strong>2019-12-12 08:44:33 PM</strong>
                </li>
                <li>
                  <i class="fas fa-file-alt"></i> Cancellation remarks: <strong>
                    Client
                  requested to cancel the invoice.
                  </strong> 
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  